/*
 * Copyright 2019 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Catapult REST API Reference
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.7.15
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import ServerDTO from '../model/ServerDTO';
import StorageInfoDTO from '../model/StorageInfoDTO';

/**
* DiagnosticRoutes service.
* @module api/DiagnosticRoutesApi
* @version 0.7.15
*/
export default class DiagnosticRoutesApi {

    /**
    * Constructs a new DiagnosticRoutesApi. 
    * @alias module:api/DiagnosticRoutesApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Get the storage information of the node
     * Returns diagnostic information about the node storage.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/StorageInfoDTO} and HTTP response
     */
    getDiagnosticStorageWithHttpInfo() {
      let postBody = null;


      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = StorageInfoDTO;

      return this.apiClient.callApi(
        '/diagnostic/storage', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * Get the storage information of the node
     * Returns diagnostic information about the node storage.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/StorageInfoDTO}
     */
    getDiagnosticStorage() {
      return this.getDiagnosticStorageWithHttpInfo()
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Get the version of the running rest component
     * Returns the version of the running rest component.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ServerDTO} and HTTP response
     */
    getServerInfoWithHttpInfo() {
      let postBody = null;


      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ServerDTO;

      return this.apiClient.callApi(
        '/diagnostic/server', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * Get the version of the running rest component
     * Returns the version of the running rest component.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ServerDTO}
     */
    getServerInfo() {
      return this.getServerInfoWithHttpInfo()
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
